import React from 'react'
import {Fragment} from 'react'

 const About = ()=> {
    return (
        <Fragment>
            <h1>This is the about page </h1>
            <p>Web application to search github users using the github API</p>
        </Fragment>
    )
}
export default About;